const Styles = {
    'GroupHeader': 'GroupHeader_GroupHeader--c8f34f83',
    'groupName': 'GroupHeader_groupName--52818240',
    'resultCount': 'GroupHeader_resultCount--2298ec82',
    'toggleButton': 'GroupHeader_toggleButton--104d3b88'
};

export default Styles;